import {AdminUserCreateRequest, UserResponse} from "../Models/Models";
import {Constants} from "../Models/Constants";

export const toAdminUserForm = (user: UserResponse): AdminUserCreateRequest => ({
    ...Constants.defaultAdminUserCreateRequest,
    displayName: user.displayName,
    email: user.email,
    isSuperAdmin: user.isSuperAdmin,
    isPasswordTemporary: user.isPasswordTemporary,
    websiteIds: user.websites.map(website => website.id),
});